module.exports = __webpack_public_path__ + "img/binance-logo-mini.f9775b57.svg";